import Dexie, { type Table } from 'dexie';
import type { PersistedClient, Persister } from '@tanstack/query-persist-client-core';

interface CacheEntry {
  key: string;
  state: string;
  updatedAt: number;
}

class QueryCacheDatabase extends Dexie {
  cache!: Table<CacheEntry, string>;

  constructor() {
    super('vivatis-pdb-query-cache');
    this.version(1).stores({ cache: 'key' });
  }
}

const db = new QueryCacheDatabase();
const CACHE_KEY = 'tanstack-query-client';

export function createDexiePersister(): Persister {
  return {
    persistClient: async (client: PersistedClient) => {
      await db.cache.put({
        key: CACHE_KEY,
        state: JSON.stringify(client),
        updatedAt: Date.now(),
      });
    },
    restoreClient: async (): Promise<PersistedClient | undefined> => {
      const entry = await db.cache.get(CACHE_KEY);
      if (!entry) return undefined;
      return JSON.parse(entry.state) as PersistedClient;
    },
    removeClient: async () => {
      await db.cache.delete(CACHE_KEY);
    },
  };
}

export async function clearPersistedQueryCache(): Promise<void> {
  await db.cache.clear();
}
